export default __webpack_public_path__ + "static/media/menu-mobile.bc680a2f.svg";